import { React, useEffect, useState } from "react"
import { Button, Form, Image, Modal, Row } from "react-bootstrap"
import InputBox from "../../common/InputBox"
import xclose from "../../../assets/icons/x-close.svg";
import SearchSelect from "../../common/SearchSelect";
import { editLostOrderData, getMasterData } from "../../../services/enquiryMaster-service";
import ConfirmAlertModal from "../../common/confirmAlertModal";
import Alert from "../../common/Alert";
import MultiSearchSelect from "../../common/multiSelect";
import _ from "lodash";
import WariningAlertModal from "../../common/WariningAlertModal";
import Loader from "../../../assets/loader.gif";

const OrderLostMaster = (props) => {
    console.log("props in order lost modal: ", props)

    const [show, setShow] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const [waringMessage, setWaringMessage] = useState(false);
    const [showAll, setShowAll] = useState({ Lostto: false });
    const [errors, setErrors] = useState({});
    const [mandatoryFields, setMandatoryFields] = useState([]);
    const [formValues, setFormValues] = useState(props.result);
    const [masterData, setMasterData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const LostToOption = []
    masterData.filter((Type) => Type.title === "Competitor").flatMap((Type) => Type.value.split(',')).map((value) => {
        LostToOption.push(value)
        return (
            <option key={value} value={value}>
                {value}
            </option>
        )
    });

    const LostReasonOptions = masterData.filter((Type) => Type.title === "Enquiry Lost Reason").flatMap((Type) => Type.value.split(',')).map((value) => (
        <option key={value} value={value}>
            {value}
        </option>
    ));

    const fetchData = async () => {
        try {
            const values = await getMasterData();
            setMasterData(values.data.map((item) => ({ title: item.Title, value: item.Value })));
        } catch (error) {
            console.error("error in catch", error);
        }
    }
    useEffect(() => {
        fetchData();
    }, [])

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!isFormSubmitted) {
                event.preventDefault();
                event.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isFormSubmitted]);


    const handleAdd = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = {
                ID: String(formValues.ID),
                Enquiry_Number: formValues.EnquiryNumber ? String(formValues.EnquiryNumber) : "",
                Lost_To: formValues.Lostto ? ('results' in formValues.Lostto ? formValues.Lostto.results : formValues.Lostto) : "",
                BOM_Price: formValues.OurBOMprice ? String(formValues.OurBOMprice) : "",
                Competitor_Final_Price: formValues.Competitorfinalprice ? String(formValues.Competitorfinalprice) : "",
                Lost_Reason: formValues.Lostreason,
                Remarks_Order_lost: formValues.Remarks_Order_lost
            }
            await editLostOrderData(data)
                .then((result) => {
                    console.log("result in lost order: ", result)
                    setLoading(false);
                    Alert("success", result.message);
                    setIsFormSubmitted(true);
                    props.reload(true);
                    props.showForm(false);
                    props.hideForm(false);
                    setShow(false)
                })
                .catch((error) => {
                    console.log("error in lost order: ", error.data.message)
                    setLoading(false);
                    Alert("error", error.data.message);
                });
        } catch (err) {
            setLoading(false);
            Alert("error", err.message)
        }
    }

    const resetForm = () => {
        setErrors("")
        setFormValues((prevState) => ({
            ...prevState,
            OurBOMprice: "",
            Competitorfinalprice: "",
            Lostto: "",
            Lostreason: "",
            Remarks_Order_lost: ""
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShow(true);
    }

    const handleCloseConf = () => {
        setShow(false);
    };

    const handleCloseWarningConf = () => {
        setShowWarning(false);
    };

    const handleCrossClick = () => {
        props.reload(true);
        props.showForm(false);
        props.hideForm(false);
        props.handleClose();
    };

    const checkUpdates = async (e) => {
        e.preventDefault();
        console.log("props.rowdata", props.result, "formfields", formValues);
        setShowWarning(true);
        setWaringMessage("After exit not able to edit data, are you sure you want to exit");
    };

    const handleToggleShowAll = (name) => {
        setShowAll((prevShowAll) => ({
            ...prevShowAll,
            [name]: !prevShowAll[name],
        }));
    };

    return (
        <>

            {loading && (
                <div className="loader-box">
                    {" "}
                    <img src={Loader} alt="Loading" className="newloader"></img>{" "}
                </div>
            )}

            {showWarning && <WariningAlertModal
                action={"Edit"}
                handleYes={handleCrossClick}
                formName={"Order Lost"}
                show={showWarning}
                handleClose={handleCloseWarningConf}
                waringMessage={waringMessage}
            />}
            {show && <ConfirmAlertModal
                action={"Edit"}
                handleYes={handleAdd}
                formName={"Order Lost"}
                show={show}
                handleClose={handleCloseConf}
            />}

            <Modal
                {...props}
                backdrop="static"
                className="orderlostModal"
                show={props.show}
                onHide={props.handleClose}
                animation={false}
            >
                <Modal.Header>
                    <Modal.Title>Edit Order Lost</Modal.Title>
                    {/* <Image src={xclose} onClick={checkUpdates}></Image> */}
                </Modal.Header>

                <Modal.Body>
                    <div className="mandatory-note">* Mandatory fields</div>
                    <div>
                        <Form onSubmit={handleAdd}>
                            <div className="scrollForm orderLost">
                                <div className="form-right-adjust">
                                    <Row className="modal-row add-edit-form">
                                        <InputBox
                                            type="text"
                                            name="ID"
                                            id="ID"
                                            value={formValues.ID}
                                            label="Enquiry No"
                                            fieldName="Enquiry No"
                                            onChange={handleInputChange}
                                            maxLength={100}
                                            placeholder=""
                                            setError={setErrors}
                                            error={errors.ID}
                                            hint="Enter enquiry no"
                                            disabled
                                        />

                                        <InputBox
                                            type="text"
                                            name="EnquiryNumber"
                                            id="EnquiryNumber"
                                            value={formValues.EnquiryNumber}
                                            label="Description Enquiry No"
                                            fieldName="Description Enquiry No"
                                            onChange={handleInputChange}
                                            maxLength={100}
                                            placeholder=""
                                            setError={setErrors}
                                            error={errors.EnquiryNumber}
                                            hint="Enter description enquiry no"
                                            isAlphanumericWithSpecialChars
                                            disabled
                                        />
                                    </Row>

                                    <Row className="modal-row add-edit-form">
                                        <InputBox
                                            type="text"
                                            name="OurBOMprice"
                                            id="OurBOMprice"
                                            value={formValues.OurBOMprice}
                                            label="Our BOM Price In Lakhs*"
                                            fieldName="BOM price in lakhs"
                                            onChange={handleInputChange}
                                            maxLength={20}
                                            placeholder=""
                                            required
                                            mandatoryFields={mandatoryFields}
                                            setMandatoryFields={setMandatoryFields}
                                            setError={setErrors}
                                            error={errors.OurBOMprice}
                                            hint="Enter BOM price in lakhs"
                                            isNumeric
                                        />

                                        <InputBox
                                            type="text"
                                            name="Competitorfinalprice"
                                            id="Competitorfinalprice"
                                            value={formValues.Competitorfinalprice}
                                            label="Competitor Final Price In Lakhs*"
                                            fieldName="Competitor final price in lakhs"
                                            onChange={handleInputChange}
                                            maxLength={20}
                                            placeholder=""
                                            required
                                            mandatoryFields={mandatoryFields}
                                            setMandatoryFields={setMandatoryFields}
                                            setError={setErrors}
                                            error={errors.Competitorfinalprice}
                                            hint="Enter competitor final price in lakhs"
                                            isNumeric
                                        />
                                    </Row>

                                    <Row className="modal-row add-edit-form">
                                        <MultiSearchSelect
                                            options={LostToOption}
                                            name="Lostto"
                                            value={formValues.Lostto && formValues.Lostto.results ? formValues.Lostto.results : formValues.Lostto || []}
                                            label="Lost To*"
                                            fieldName="Lost to"
                                            onChange={handleInputChange}
                                            hint="Enter Lost to"
                                            showAll={showAll.Lostto}
                                            onToggleShowAll={() => handleToggleShowAll('Lostto')}
                                            setError={setErrors}
                                            required
                                            mandatoryFields={mandatoryFields}
                                            setMandatoryFields={setMandatoryFields}
                                            error={errors.Lostto}
                                        />
                                    </Row>

                                    <Row className="modal-row add-edit-form">
                                        <SearchSelect
                                            name="Lostreason"
                                            value={formValues.Lostreason}
                                            option={LostReasonOptions}
                                            label="Lost Reason*"
                                            id="Lostreason"
                                            fieldName="Lost Reason"
                                            onChange={handleInputChange}
                                            placeholder=""
                                            required
                                            mandatoryFields={mandatoryFields}
                                            setMandatoryFields={setMandatoryFields}
                                            setError={setErrors}
                                            error={errors.Lostreason}
                                            hint="Enter lost reason"
                                            isAlphaNumericSpace
                                        />

                                        <InputBox
                                            type="text"
                                            name="Remarks_Order_lost"
                                            id="Remarks_Order_lost"
                                            value={formValues.Remarks_Order_lost}
                                            label="Remarks"
                                            fieldName="Remarks"
                                            onChange={handleInputChange}
                                            maxLength={500}
                                            placeholder=""
                                            setError={setErrors}
                                            error={errors.Remarks_Order_lost}
                                            hint="Enter remarks"
                                            isAlphanumericWithSpecialChars
                                        />
                                    </Row>
                                </div>
                            </div>

                            <Modal.Footer>
                                {/* <Button bsPrefix="reset-btn" onClick={resetForm} className="modal-btn-sub">Reset</Button> */}
                                <Button variant="primary" type="submit" className="modal-btn-sub"
                                    disabled={
                                        !formValues.OurBOMprice || !formValues.Competitorfinalprice || !formValues.Lostto || !formValues.Lostreason
                                        || (errors.OurBOMprice && errors.OurBOMprice != "")
                                        || (errors.Competitorfinalprice && errors.Competitorfinalprice != "")
                                        || (errors.Lostto && errors.Lostto != "")
                                        || (errors.Lostreason && errors.Lostreason != "")
                                        || (errors.Remarks_Order_lost && errors.Remarks_Order_lost != "")
                                    }
                                >
                                    Save
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default OrderLostMaster
